var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleClassroom128(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "128px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Va",
    x1: 42,
    x2: 42,
    y1: 28,
    y2: 34,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Va)",
    d: "M42 28A3 3 0 1 0 42 34A3 3 0 1 0 42 28Z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Vb",
    x1: 32,
    x2: 32,
    y1: 11.25,
    y2: 52.782,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Vb)",
    d: "M51.863,11H12.137C9.855,11,8,12.865,8,15.158v33.684C8,51.135,9.855,53,12.137,53h39.727 C54.145,53,56,51.135,56,48.842V15.158C56,12.865,54.145,11,51.863,11z M54,48.842C54,50.032,53.041,51,51.863,51H12.137 C10.959,51,10,50.032,10,48.842V15.158C10,13.968,10.959,13,12.137,13h39.727C53.041,13,54,13.968,54,15.158V48.842z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Vc",
    x1: 32,
    x2: 32,
    y1: 11.25,
    y2: 52.782,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Vc)",
    d: "M51,15H13c-0.553,0-1,0.447-1,1v32c0,0.553,0.447,1,1,1h38c0.553,0,1-0.447,1-1V16 C52,15.447,51.553,15,51,15z M50,47h-4v-2H36v2H14V17h36V47z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Vd",
    x1: 32,
    x2: 32,
    y1: 11.25,
    y2: 52.782,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Vd)",
    d: "M32,32c2.206,0,4-1.794,4-4s-1.794-4-4-4s-4,1.794-4,4S29.794,32,32,32z M32,26 c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2S30.897,26,32,26z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Ve",
    x1: 32,
    x2: 32,
    y1: 11.25,
    y2: 52.782,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Ve)",
    d: "M39.5,36.32l-0.305-0.295C39.068,35.902,36.025,33,32,33s-7.068,2.902-7.195,3.025L24.5,36.32 V41h15V36.32z M37.5,39h-11v-1.802C27.275,36.562,29.438,35,32,35s4.725,1.562,5.5,2.198V39z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Vf",
    x1: 42.755,
    x2: 42.755,
    y1: 35,
    y2: 41,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Vf)",
    d: "M47,37.37V41h-7.5v-4.68l-0.3-0.29c-0.03-0.04-0.27-0.27-0.69-0.59 C39.37,35.15,40.24,35,41.1,35c3.1,0,5.45,1.99,5.55,2.07L47,37.37z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Vg",
    x1: 22,
    x2: 22,
    y1: 28,
    y2: 34,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Vg)",
    d: "M22 28A3 3 0 1 0 22 34A3 3 0 1 0 22 28Z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "BWORzew7~ao8gV5bt~h4Vh",
    x1: 21.245,
    x2: 21.245,
    y1: 35,
    y2: 41,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#BWORzew7~ao8gV5bt~h4Vh)",
    d: "M25.49,35.44c-0.42,0.32-0.66,0.55-0.69,0.59l-0.3,0.29V41H17v-3.63l0.35-0.3 C17.45,36.99,19.8,35,22.9,35C23.76,35,24.63,35.15,25.49,35.44z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleClassroom128);
export default __webpack_public_path__ + "static/media/google-classroom-128.c9705cb0fcb0cfb2cbd004cfe12b5ff6.svg";
export { ForwardRef as ReactComponent };